import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Toast } from '@stylehaven/components';

import { AddToast, DeleteToast, UnsetToasts, UpdateToast, UpsertToast } from './toast.actions';

export interface State extends EntityState<Toast> {}

export const adapter: EntityAdapter<Toast> = createEntityAdapter<Toast>();

export const initialState: State = adapter.getInitialState();

export const toastReducer = createReducer(
    initialState,
    on(AddToast, (state, { toast }) => {
        return adapter.addOne(toast, state);
    }),
    on(UpsertToast, (state, { toast }) => {
        return adapter.upsertOne(toast, state);
    }),
    on(UpdateToast, (state, { id, toast }) => {
        return adapter.updateOne({ id, changes: toast }, state);
    }),
    on(DeleteToast, (state, { id }) => {
        return adapter.removeOne(id, state);
    }),
    on(UnsetToasts, state => {
        return adapter.removeAll(state);
    })
);

export function reducer(state: State | undefined, action: Action) {
    return toastReducer(state, action);
}

// get the selectors
export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
